import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select$ } from '@angular-redux3/store';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Artist, Media, Playlist, Tempo } from '../../store/entities';
import { removeDuplicates } from '../../utils';
import { Router } from '@angular/router';

type SearchFn = <T>(obs$: Observable<Array<T>>, accessors: string[]) => Observable<T[]>;

@Component({
  selector: 'mwo-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchPage implements OnInit, OnDestroy {
  @Select$('playlists', obs$ => obs$.pipe(
    map(({ events, tempos }) => [...Object.values(events), ...Object.values(tempos)])
  ))
  fullPlaylists$: Observable<Array<Playlist | Tempo>>;

  // @ts-ignore
  fullTracks$: Observable<Media[]> = this.fullPlaylists$.pipe(
    map<Array<Playlist | Tempo>, Media[]>(events => events.flatMap((event) =>
      event.assoMediaEvent?.map(({ media }) => media).reduce(removeDuplicates(), [])
    )),
  );
  fullArtists$: Observable<Artist[]> = this.fullTracks$.pipe(
    map(tracks => tracks.map(({ artist }) => artist).reduce(removeDuplicates(), [])),
  );

  playlists$: BehaviorSubject<Array<Playlist | Tempo>> = new BehaviorSubject([]);
  tracks$: BehaviorSubject<Array<Media>> = new BehaviorSubject([]);
  artists$: BehaviorSubject<Array<Artist>> = new BehaviorSubject([]);
  showResults = false;
  showNotFound = false;
  searchSubscription: Subscription;

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  getCoverUrl(path: string): string {
    return `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${path}`;
  }

  handleSearch(searchFn: SearchFn) {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    this.showResults = true;
    this.searchSubscription = combineLatest(
      [
        searchFn<Playlist | Tempo>(this.fullPlaylists$, ['name']),
        searchFn<Artist>(this.fullArtists$, ['name']),
        searchFn<Media>(this.fullTracks$, ['title'])
      ]
    ).subscribe(([playlists, artists, tracks]) => {
      this.playlists$.next(playlists);
      this.artists$.next(artists);
      this.playlists$.next(playlists);

      if (!playlists.length && !artists.length && !tracks.length) {
        this.showNotFound = true;
        this.showResults = false;
      } else {
        this.showNotFound = false;
        this.showResults = true;
      }
    });
  }

  handleEmptyValue() {
    this.showNotFound = false;
    this.showResults = false;
  }

  handleCardClick(path, itemId = '') {
    if (itemId) {
      this.router.navigate([path, itemId]);
    } else {
      this.router.navigate([path]);
    }
  }

  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }
}
